var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('div', {
    staticClass: "profie-img"
  }, [_c('img', {
    staticClass: "img-fluid cursor-pointer",
    staticStyle: {
      "height": "200px",
      "width": "200px"
    },
    attrs: {
      "alt": "player profile image",
      "src": _vm.makeAvatar(_vm.avatar)
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.file.click();
      }
    }
  }), _c('input', {
    ref: "file",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadAvatar,
      "click": _vm.resetImageUploader
    }
  }), _c('button', {
    staticClass: "text-primary border-0 mt-3 pointer profile-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.file.click();
      }
    }
  }, [_vm._v("Change")]), _vm.avatar.length > 25 ? _c('button', {
    staticClass: "text-danger border-remove mt-3 pointer profile-btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.removeAvatar
    }
  }, [_vm._v("Remove")]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }